// extracted by mini-css-extract-plugin
module.exports = {"deviceSections":"DeviceSections--deviceSections--2K6wz","spacerSection":"DeviceSections--spacerSection--2e9Rz","debug":"DeviceSections--debug--1npdE"};